import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { useFeatureGate } from "~api/useFeatureGate";
import { useBusinessConfig } from "~contexts/BusinessConfigContext/BusinessConfigContext.tsx";
import { useCurrentTenant } from "~contexts/CurrentTenantContext/CurrentTenantContext.tsx";
import { useTranslation } from "~contexts/I18nContext/I18nContext.tsx";
import { useUserProfile } from "~contexts/UserProfileContext/UserProfileContext.tsx";
import { config } from "~initializer/config.ts";

import styles from "./DashboardDirectLinks.module.scss";

export function DashboardDirectLinks() {
  const t = useTranslation();
  const callbackPortalUrl = useCallbackPortalUrl();

  if (!callbackPortalUrl) return null;

  return (
    <section className={styles.directLinks}>
      <h2 className={styles.title}>{t.dashboardDirectLinksTitle}</h2>
      <a
        className={styles.link}
        href={callbackPortalUrl}
        target="_blank"
        rel="noopener noreferrer"
      >
        {t.dashboardDirectLinksCallbackPortal}
        <OpenInNewIcon fontSize="small" />
      </a>
    </section>
  );
}

function useCallbackPortalUrl() {
  const { callbackPortalGroups } = useBusinessConfig();
  const { groupIds } = useUserProfile();
  const { shortName } = useCurrentTenant();
  const { enabled, settled } = useFeatureGate("callback_portal_link");

  const hasAccess = callbackPortalGroups.some((group) =>
    groupIds.includes(group.id),
  );
  if (!settled || !enabled || !hasAccess) return undefined;

  return config().callbackPortalUrl.replace(
    "{site}",
    shortName.replaceAll(" ", ""),
  );
}
